"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsoluteOverlay = exports.FixedOverlay = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const overlayBase = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 20;

  background: rgba(0, 0, 0, 0.5);
`;
exports.FixedOverlay = (0, styled_components_1.default)(overlayBase) `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
exports.AbsoluteOverlay = (0, styled_components_1.default)(overlayBase) `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
//# sourceMappingURL=overlays.js.map